import { useMemo } from "react"
import markdownit from "markdown-it"
import { GetApp } from "../DemoApp"
import { LocalizationReplaceText, LanguageTextReplacements } from "../../app/App/Localization"
import { classNames } from "../../app/Components"
import enDemosYaml from "../Language/en.yaml"
import deDemosYaml from "../Language/de.yaml"

interface DemoUIMessages {
  [key: string]: string;
}

interface DemoSceneMessages {
  [frame: string]: string;
}

export interface DemoScenesMessages {
  concept: DemoSceneMessages;
  quickstart: DemoSceneMessages;
  quickstartVoyage: DemoSceneMessages;
}

export interface DemoMessages {
  demo: DemoScenesMessages;
  ui: DemoUIMessages;
}

const enDemos = enDemosYaml as DemoMessages;
const deDemos = deDemosYaml as DemoMessages;

export const DemoLocalization = {
  en: enDemos,
  de: deDemos,
};

interface MessageCallback {
  (message: DemoMessages): string | undefined;
}

interface LocalizedMessageProps {
  className?: string;
  html?: boolean;
  message: MessageCallback;
  replace?: LanguageTextReplacements;
}

export function LocalizedMessage({ className, html, message, replace }: LocalizedMessageProps) {
  const app = GetApp();
  const text = useMemo(() => {
    const messages = DemoLocalization[app.language as keyof typeof DemoLocalization] ?? enDemos;
    const md = markdownit({ html: html || false });
    const text = LocalizationReplaceText(message(messages) || "", replace);
    return md.render(text);
  }, [message, app.language]);
  return <div className={classNames(["LocalizedMessage", className])} dangerouslySetInnerHTML={{ __html: text }} />;
}
